import * as i0 from '@angular/core';
import { Pipe, Inject, NgModule } from '@angular/core';
import { TUI_SVG_OPTIONS } from '@taiga-ui/core/components/svg';
import { TUI_CACHE_BUSTING_PAYLOAD } from '@taiga-ui/core/constants';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';

class TuiFlagPipe {
    constructor(svgOptions) {
        this.svgOptions = svgOptions;
        this.staticPath = this.svgOptions
            .path('tuiIcon')
            .replace('tuiIcon.svg#tuiIcon', '')
            .replace(`tuiIcon.svg${TUI_CACHE_BUSTING_PAYLOAD}#tuiIcon`, '');
    }
    transform(countryIsoCode) {
        if (!countryIsoCode) {
            return null;
        }
        switch (countryIsoCode) {
            case TuiCountryIsoCode.BL:
            case TuiCountryIsoCode.BQ:
            case TuiCountryIsoCode.CW:
            case TuiCountryIsoCode.GF:
            case TuiCountryIsoCode.GP:
            case TuiCountryIsoCode.MF:
            case TuiCountryIsoCode.MQ:
            case TuiCountryIsoCode.NC:
            case TuiCountryIsoCode.RE:
            case TuiCountryIsoCode.YT:
                return `${this.staticPath}${TuiCountryIsoCode.FR}.png`;
            case TuiCountryIsoCode.SX:
                return `${this.staticPath}${TuiCountryIsoCode.NL}.png`;
            default:
                return `${this.staticPath}${countryIsoCode}.png`;
        }
    }
}
TuiFlagPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipe, deps: [{ token: TUI_SVG_OPTIONS }], target: i0.ɵɵFactoryTarget.Pipe });
TuiFlagPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipe, name: "tuiFlag" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'tuiFlag' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TUI_SVG_OPTIONS]
                }] }]; } });

class TuiFlagPipeModule {
}
TuiFlagPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiFlagPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipeModule, declarations: [TuiFlagPipe], exports: [TuiFlagPipe] });
TuiFlagPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipeModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFlagPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiFlagPipe],
                    exports: [TuiFlagPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFlagPipe, TuiFlagPipeModule };
